const redgateRed = '#cc0000';

const buttonStyle = {
    backgroundColor: '#336dc2'
};

const holeStyle = {
    backgroundColor: 'rgba(255,255,255,0.2)'
};

const JoyrideStepStyle = {
    header: {
        borderColor: redgateRed
    },
    button: buttonStyle,
    hole: holeStyle
};

const JoyrideStepNoArrowStyle = {
    header: {
        borderColor: redgateRed
    },
    button: buttonStyle,
    hole: holeStyle,
    arrow: {
        display: 'none'
    }
};

const JoyrideStartStepStyle = {
    backgroundColor: redgateRed,
    color: '#fff',
    textAlign: 'left',
    width: '600px',
    header: {
        fontSize: '36px',
        borderBottom: '1px solid #fff',
        paddingTop: '10px',
        paddingBottom: '20px',
        marginLeft: '10px',
        marginRight: '10px',
        textAlign: 'center'
    },
    main: {
        padding: '10px'
    },
    footer: {
        padding: '10px'
    },
    arrow: {
        display: 'none',
    },
    button: {
        backgroundColor: '#fff',
        padding: '10px',
        fontSize: '20px',
        color: redgateRed
    },
    skip: {
        color: '#eb9999'
    },
    hole: {
        backgroundColor: 'transparent',
        maxHeight: 0
    },
};

const JoyrideFinishStepStyle = {
    width: '600px',
    skip: {
        display: 'none',
    },
    hole: {
        backgroundColor: 'transparent',
        maxHeight: 0
    },
    arrow: {
        display: 'none',
    },
    button: {
        display: 'none'
    },
    header: {
        borderColor: redgateRed,
        fontSize: '30px',
        lineHeight: '40px',
        paddingTop: '10px',
        paddingBottom: '20px',
        marginLeft: '10px',
        marginRight: '10px',
        textAlign: 'center'
    },
    main: {
        padding: '10px',
        textAlign: 'center'
    }
};

export {
    JoyrideStepStyle,
    JoyrideStepNoArrowStyle,
    JoyrideStartStepStyle,
    JoyrideFinishStepStyle
};



// WEBPACK FOOTER //
// ./src/components/common/Joyride/steps.jsx